import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { newestApplicationVersion$ } from './features/automatic-update/newest-application-version';

const VERSION_HEADER = 'X-Application-Version';
const INITIAL_VERSION = '1';

@Injectable()
export class ApplicationVersionInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((response: HttpResponse<any>) => {
        if (!response.headers) {
          return;
        }

        const version = this.getVersion(response);
        newestApplicationVersion$.next(version);
      }),
    );
  }

  private getVersion(response: HttpResponse<any>) {
    const headerValue = response.headers.get(VERSION_HEADER);
    const version = parseInt(headerValue || INITIAL_VERSION, 10);

    return { version };
  }
}
